import React, { Component } from 'react';
import { CardHeader as CardHeaderBootstrap } from 'reactstrap';
import { MdKeyboardArrowDown } from 'react-icons/lib/md';

const CartaoCabecalhoHOC = CardHeaderBootstrap =>
  class PropsProxy extends Component {

    quandoClicar = ({ target }) => {
      let id = target.id;
      while (!id) {
        target = target.parentNode;
        id = target.id;
      }
      console.log(id);
      this.props.onClick(id);
    }

    render() {
      const { titulo, expandido, id, ...resto } = Object.assign({}, this.props, { onClick: this.quandoClicar });
      return (
        <CardHeaderBootstrap {...resto}>
          <i id={id}>{titulo}
            <MdKeyboardArrowDown
              size={20}
              style={{
                padding: 0,
                transform: expandido
                  ? 'rotate(0deg)'
                  : 'rotate(-90deg)',
                transitionDuration: '0.3s',
                transitionProperty: 'transform',
              }}
            />
          </i>
        </CardHeaderBootstrap>
      )
    }
  }

export const CardHeader = CartaoCabecalhoHOC(CardHeaderBootstrap);


// WEBPACK FOOTER //
// ./src/componentes/uteis.js